import { useTranslate } from "@opensea/next-translate"
import { Repeat } from "@opensea/ui-kit/icons"
import { usePrivy } from "@privy-io/react-auth"
import React from "react"
import { ShowMoreIcon } from "@/components/common/ShowMoreIcon"
import { WALLET_NAME } from "@/constants/wallet"
import { useIsOpen } from "@/hooks/useIsOpen"
import { PageTrackingContextProvider } from "@/lib/analytics/TrackingContext/contexts/PageTrackingContext/PageTrackingContext.react"
import { useConnectedWallet } from "@/providers/Wallet/selectors"
import { UIProviders } from "@/providers/UIProviders"
import { ENVIRONMENT } from "@/constants/env"
import { WalletSwitcher } from "../WalletSwitcher"
import { useWalletOptions } from "../WalletSwitcher/useWalletOptions"
import { ExportPrivateKeyItem } from "./components/ExportPrivateKeyItem.react"
import { LogoutItem } from "./components/LogoutItem.react"
import { MfaItem } from "./components/MfaItem.react"
import { SettingsItem } from "./components/SettingsItem.react"
import { DebugItem } from "./components/DebugItem"

export function SettingsPage() {
  const walletOptions = useWalletOptions()

  const { isOpen: isWalletSwitcherOpen, toggle: toggleWalletSwitcher } =
    useIsOpen()

  const t = useTranslate("settings")

  const { ready, authenticated } = usePrivy()
  const connectedWallet = useConnectedWallet()
  const shouldShowExportPrivateKey =
    connectedWallet === WALLET_NAME.OpenSeaWallet && ready && authenticated

  return (
    <UIProviders>
      <PageTrackingContextProvider name="Activity">
        <div className="mb-4 px-6 pt-6 text-heading-md font-semibold">
          {t("settings", "Settings")}
        </div>
        <div className="mx-3 flex flex-col gap-1">
          {ENVIRONMENT === "development" && <DebugItem />}
          {walletOptions.length > 1 && (
            <SettingsItem
              actionIcon={<ShowMoreIcon isActive={isWalletSwitcherOpen} />}
              icon={<Repeat />}
              label={t("settingsPage.switchWallet", "Switch profile")}
              onClick={toggleWalletSwitcher}
            />
          )}
          {isWalletSwitcherOpen ? <WalletSwitcher /> : null}
          {connectedWallet === WALLET_NAME.OpenSeaWallet && <MfaItem />}
          {shouldShowExportPrivateKey ? <ExportPrivateKeyItem /> : null}
          {connectedWallet ? <LogoutItem /> : null}
        </div>
      </PageTrackingContextProvider>
    </UIProviders>
  )
}
